module.exports = __webpack_public_path__ + "media/images/icons/magnifier-d5acceaef55ed31bbafb27b6607ce628.svg";